<template>
	<header>
		<nav class="navbar navbar-expand-lg navbar-light fixed-top p-md-0 pt-0 pb-0">
			<nav class="container p-0">
				<router-link :to="{ name: 'home' }" class="navbar-brand"><img class="img-fluid navbar-logo" width="90%" height="90%" src="/assets/logo-milagros.png"></router-link>
				<button class="navbar-toggler" id="navbar-mobile-toggler">
					<span class="navbar-toggler-icon">
						<img class="img-fluid" src="/assets/icon/ic_menu_white.png" alt="">
					</span>
				</button>
				<div class="collapse navbar-collapse" id="navbarNavDropdown">
					<ul class="navbar-nav ml-auto">
						<li class="nav-item" :class="{active:this.$route.name=='home'}">
							<router-link :to="{ name: 'home' }" class="nav-link link-white">Beranda <span class="sr-only">(current)</span></router-link>
						</li>
						<li class="nav-item ml-3" :class="{active:this.$route.name=='products'}">
							<router-link :to="{ name: 'products' }" class="nav-link link-white">Produk</router-link>
						</li>
						<li class="nav-item ml-3" v-if="!this.isAuth" :class="{active:this.$route.name=='cek-transaksi'}">
							<router-link :to="{ name: 'cek-transaksi' }" class="nav-link link-white">Cek Status Transaksi</router-link>
						</li>
						<li class="nav-item ml-3" v-if="this.isAuth" :class="{active:this.$route.name=='transaction'}">
							<router-link :to="{ name: 'transaction' }" class="nav-link link-white">Transaksi</router-link>
						</li>
						<li class="nav-item ml-3" v-if="this.isAuth" :class="{active:this.$route.name=='address' || this.$route.name=='bank'}">
							<div class="dropdown">
								<a href="javascript:;" class="nav-link link-white">Pengaturan</a>
								<div class="dropdown-content">
									<router-link :to="{ name: 'address' }" class="nav-link link-white pl-3">Pengaturan Alamat</router-link>
									<router-link :to="{ name: 'bank' }" href="#" class="nav-link link-white pl-3">Pengaturan Bank</router-link>
								</div>
							</div>
							<!-- <router-link :to="{ name: 'address' }" class="nav-link link-white">Pengaturan Alamat</router-link> -->
						</li>
						<li class="nav-item ml-3" :class="{active:this.$route.name=='panduan'}">
							<router-link :to="{ name: 'panduan' }" class="nav-link link-white">Panduan</router-link>
						</li>
						<li class="nav-item ml-3 mr-1" :class="{active:this.$route.name=='cart'}">
							<router-link :to="{ name: 'cart' }" class="nav-link link-white">
								<span><i class="fas fa-shopping-cart"></i></span>
								<span class="badge background-purple color-white rounded-pill position-absolute mt-n1 ml-n1">{{total_cart ? total_cart : '' }}</span>
							</router-link>
						</li>
						<li class="nav-item ml-3 mt-1" v-if="!this.isAuth" :class="{active:this.$route.name=='login'}">
							<router-link :to="{ name: 'login' }" class="btn background-button-template color-white border-radius-15 pl-4 pr-4 shadow-login">Login</router-link>
						</li>
						<!-- <li class="nav-item dropdown ml-3" id="dropdown-menu" v-if="!this.isAuth">
							<a class="nav-link link-white" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<font-awesome-icon :icon="['fas', 'align-justify']"/>
							</a>
							<div class="dropdown-menu style-dropdown mt-0 " aria-labelledby="navbarDropdownMenuLink">
								<a class="dropdown-item" href="https://milagros.co.id/registrasi">Registrasi</a>
								<a class="dropdown-item" href="https://milagros.co.id/about-us">Tentang Milagros</a>
								<a class="dropdown-item" href="https://milagros.co.id/news">Berita Terbaru</a>
								<a class="dropdown-item" href="https://milagros.co.id/page/read/9/terms-of-service">Terms Of Service</a>
								<a class="dropdown-item" href="https://milagros.co.id/serial/check">Cek Kartu</a>
								<a class="dropdown-item" href="https://milagros.co.id/event">Event</a>
							</div>
						</li> -->
						<li class="nav-item ml-3" v-if="this.isAuth">
							<router-link to="/login" v-on:click.native="onLogout()" class="nav-link link-white">Logout</router-link>
						</li>
					</ul>
				</div>
			</nav>
		</nav>
		<nav class="navbar-mobile" id="navbar-mobile">
			<nav class="navbar-background-mobile">
				<nav class="menu-button-close" id="menu-button-close">
					<a class="nav-link color-white" href="javascript:;">
						<!-- <i class="fa fa-times font-size-20"></i> -->
						<font-awesome-icon :icon="['fas', 'times']" class="font-size-20"/>
					</a>
				</nav>
			</nav>
			<nav class="menu-mobile" id="menu-mobile">
				<ul class="item-footer pt-2 pl-0">
					<li class="nav-item" :class="{active:this.$route.name=='home'}" @click="hideNav">
						<router-link :to="{ name: 'home' }" class="nav-link link-menu">BERANDA</router-link>
					</li>
					<li class="nav-item" :class="{active:this.$route.name=='products'}" @click="hideNav">
						<router-link :to="{ name: 'products' }" class="nav-link link-menu">PRODUK</router-link>
					</li>
					<li v-if="!this.isAuth" :class="{active:this.$route.name=='cek-transaksi'}" @click="hideNav">
						<router-link :to="{ name: 'cek-transaksi' }" class="nav-link link-menu">CEK TRANSAKSI</router-link>
					</li>
					<li :class="{active:this.$route.name=='cart'}" @click="hideNav">
						<router-link :to="{ name: 'cart' }" class="nav-link link-menu">
							<span>KERANJANG BELANJA</span>
							<span class="badge background-purple color-white rounded-pill position-absolute">{{total_cart ? total_cart : '' }}</span>
						</router-link>
					</li>
					<li v-if="!this.isAuth" :class="{active:this.$route.name=='login'}" @click="hideNav">
						<router-link :to="{ name: 'login' }" class="nav-link link-menu">LOGIN</router-link>
					</li>
					<li v-if="this.isAuth" :class="{active:this.$route.name=='transaction'}" @click="hideNav">
						<router-link :to="{ name: 'transaction' }" class="nav-link link-menu">TRANSAKSI</router-link>
					</li>
					<li v-if="this.isAuth" :class="{active:this.$route.name=='address'}" @click="hideNav">
						<router-link :to="{ name: 'address' }" class="nav-link link-menu">PENGATURAN ALAMAT</router-link>
					</li>
					<li v-if="this.isAuth" :class="{active:this.$route.name=='bank'}" @click="hideNav">
						<router-link :to="{ name: 'bank' }" class="nav-link link-menu">PENGATURAN BANK</router-link>
					</li>
					<li class="nav-item" :class="{active:this.$route.name=='panduan'}" @click="hideNav">
						<router-link :to="{ name: 'panduan' }" class="nav-link link-menu">PANDUAN</router-link>
					</li>
					<li v-if="this.isAuth" @click="hideNav">
						<router-link to="/login" v-on:click.native="onLogout()" class="nav-link link-menu">LOGOUT</router-link>
					</li>
				</ul>
			</nav>
		</nav>
		<div>
			<carousel class="col-12 p-0 caraousel-index" :items="1" :autoplay="true" :nav="false" :loop="true" :dots="false">
				<div class="item h-100">
					<img class="img-caraousel h-100" src="/assets/banner-milagros-new.jpg">
					<div class="caraousel-caption-self">
						<h4>Mobile Counter</h4>
						<p>Kami hadir untuk melengkapi kebutuhan anda</p>
					</div>
				</div>
				<div class="item h-100">
					<img class="img-caraousel h-100" src="/assets/banner-milagros-new.jpg">
					<div class="caraousel-caption-self">
						<h4>Mobile Counter</h4>
						<p>Kami hadir untuk melengkapi kebutuhan anda</p>
					</div>
				</div>
			</carousel>
			<div class="bubbels">
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
				<div class="bubble"><span class="glow"></span></div>
			</div>
		</div>
	</header>
</template>

<script>
import { mapGetters, createNamespacedHelpers, mapState } from 'vuex';
import carousel from 'vue-owl-carousel';
//import $ from 'jquery';

const { mapActions } = createNamespacedHelpers('auth')
//const $isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);

export default {
	name: 'MlHeader',
	components: {
		carousel
	},
	watch:{
		$route (){
			// if ($isMobile) {
			// 	$("#navbar-mobile-toggler").css("display","block");
			// 	$("#navbar-mobile").hide("fast");
			// 	$(".menu-mobile").animate({left : "-69%"}, "fast");
			// 	$("body").css("overflow","auto");
			// }
		}
	},
	methods: {
		...mapActions(['logout']),

		onLogout() {
			this.logout().then(() => {
				localStorage.clear();
				this.$router.push({ name: 'login' });
			});
		},
		hideNav() {
			document.body.style.overflow = 'auto'
			document.getElementById('navbar-mobile').style.display = 'none'
			document.getElementById('navbar-mobile-toggler').style.display = 'block'
		}
	},
	computed: {
		...mapGetters('auth', ['isAuth']),
		...mapState('cart', ['cart']),

		total_cart(){
			let total = 0
			if(this.cart){
				this.cart.forEach(element => {
					total += element.products.length
				});
				return total
			}
			return false;
		}
	}
}
</script>

<style>
header .owl-dots {
	margin-left: 0 !important;
	text-align: center !important;
}
.style-dropdown {
	margin-left: -4rem !important;
}

@media (min-width: 1921px) {
	header .caraousel-caption-self {
		margin-left: auto !important;
		text-align: center !important;
	}
}

@media (min-width: 1441px) and (max-width: 1920px) {
	header .caraousel-caption-self {
		margin-left: 24rem !important;
	}
}

@media (min-width: 1361px) and (max-width: 1440px) {
	header .caraousel-caption-self {
		margin-left: 9.5rem !important;
	}
}

@media (min-width: 1281px) and (max-width: 1360px) {
	header .caraousel-caption-self {
		margin-left: 7rem !important;
	}
}

@media (min-width: 768px) and (max-width: 1024px) {
	header .caraousel-caption-self {
		margin-left: 1.8rem !important;
	}
}

</style>
